import { useMemo, useReducer } from 'react'
import { ElementsControllerProps, OpeningElementsControllerReducer } from '@/reducers'
import { ReactSimpleComponentProps } from '@/custom-types'
import { ContextActionsProps, ModalTextProps, OpeningElementsControllerContext } from './OpeningElementsControllerContext'

const InitialState: ElementsControllerProps = {
  isChangePasswordModalOpen: false,
  isOwnerLogoutConfirmationModalOpen: false,
  isLogoutConfirmationModalOpen: false,
  isConfirmDialogModalOpen: false,
  isAddMenuModalOpen: false,
  isCreateTenantFormModalOpen: false,
  isCreateOwnerFormModalOpen: false,
  isCreateSupplierFormModalOpen: false,
  modalText: { title: '', description: '', buttonText: ''}
}

export const OpeningElementsControllerContextProvider = ({ children }: ReactSimpleComponentProps) => {
  const [state, dispatch] = useReducer(OpeningElementsControllerReducer, InitialState)
  
  const contextActions = useMemo<Omit<ContextActionsProps, 'state'>>(() => ({
    changePasswordModalOpen: () => dispatch({ type: 'CHANGE_PASSWORD_MODAL-open'}),
  
    changePasswordModalClose: () => dispatch({ type: 'CHANGE_PASSWORD_MODAL-close'}),
    
    logoutConfirmationModalOpen: () => dispatch({ type: 'LOGOUT_CONFIRMATION_MODAL-open'}),
  
    logoutConfirmationModalClose: () => dispatch({ type: 'LOGOUT_CONFIRMATION_MODAL-close'}),
    
    confirmDialogModalOpen: ({ title, description, buttonText }: ModalTextProps) => dispatch(
      {
        type: 'CONFIRM_DIALOG_MODAL-open',
        payload: { // El payload solo debe contener los datos que cambian.
          modalText: { // El reducer se encargará de fusionar esto con el estado existente.
            title,
            description,
            buttonText: buttonText,
          },
        }
      }
    ),

    confirmDialogModalClose: () => dispatch({ type: 'CONFIRM_DIALOG_MODAL-close'}),

    addMenuModalOpen: () => dispatch({ type: 'ADD_NEW_MENU_MODAL-open' }),

    addMenuModalClose: () => dispatch({ type: 'ADD_NEW_MENU_MODAL-close'}),

    createTenantFormModalOpen: () => dispatch({ type: 'CREATE_TENANT_FORM_MODAL-open'}),

    createTenantFormModalClose: () => dispatch({ type: 'CREATE_TENANT_FORM_MODAL-close'}),

    createOwnerFormModalOpen: () => dispatch({ type: 'CREATE_OWNER_FORM_MODAL-open'}),

    createOwnerFormModalClose: () => dispatch({ type: 'CREATE_OWNER_FORM_MODAL-close'}),

    createSupplierFormModalOpen: () => dispatch({ type: 'CREATE_SUPPLIER_FORM_MODAL-open'}),

    createSupplierFormModalClose: () => dispatch({ type: 'CREATE_SUPPLIER_FORM_MODAL-close'})
  }), [])
 
  return (
    <OpeningElementsControllerContext.Provider value={{ ...contextActions, state }}>
      {children}
    </OpeningElementsControllerContext.Provider>
  )
}